<template>
  <b-container id="view" style="padding: 0">
    <Navbar></Navbar>
    <b-container id="container_reglement">
      <b-row style="margin-top: 20px">
        <b-col>
          <h2 class="title_section"><b-icon icon="square-fill" class="puce"></b-icon>Réglement du Challenge Maritima</h2>
          <h3>Article 1 : PRESENTATION</h3>
          <p>La société Maritima Médias organise le "Challenge Maritima", qui regroupe seize courses pédestres situées géographiquement sur le grand pourtour de l'Étang de Berre, selon le calendrier suivant :</p>
        </b-col>
      </b-row>
      <b-row style="margin-top: 20px">
        <b-col>
          <b-table id="table_classement" hover small responsive :items="$store.state.list_courses" :fields="fields">
            <template #cell(num)="data">
              <b>{{ data.index + 1 }}</b>
            </template>
          </b-table>
          <p>À noter que le Challenge prend uniquement en compte les épreuves dont la distance est spécifiée ci-dessus.</p>
          <h3>Article 2 : DÉROULEMENT</h3>
          <p>Le challenge est ouvert à toutes les catégories hommes et femmes répondant aux conditions requises pour les 16 courses. A titre individuel, le participant doit concourir à au moins 8 épreuves pour valider le Challenge.</p>
          <h3>Article 3 : CONDITIONS DE PARTICIPATION</h3>

          <p>
            La participation au Challenge nécessite une inscription, possible du 16 janvier 2023 au 25 septembre 2023. Les inscriptions pourront se faire uniquement en ligne sur
            <a href="http://www.challenge-maritima.info" target="_blank">http://www.challenge-maritima.info</a>. L'inscription au Challenge est gratuite, en revanche la participation à chaque course demeure payante.
          </p>

          <h3>Article 4 : CLASSEMENTS</h3>
          <p>
            Pour valider leur classement final, les coureurs doivent participer au minimum à 8 courses citées en l'article 1. Ils deviendront alors « finisher » du Challenge. Les classements officiels seront établis grâce aux cumuls des points des 6
            meilleures courses. Les coureurs qui ne participeront pas au moins à 8 courses du Challenge seront hors classement.
          </p>

          <p style="text-decoration: underline">Fonctionnement du classement par points et par course :</p>
        </b-col>
      </b-row>
      <b-row style="margin-top: 20px">
        <b-col md="3"></b-col>
        <b-col md="6">
          <b-table id="table_classement" hover small responsive :items="repartition_points"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>
            Les points sont attribués sur le classement scratch, toutes catégories d'âge confondues, mais de manière distincte selon le sexe. Le classement féminin est donc établi en tenant uniquement compte des performances réalisées par les
            participantes lors d'une épreuve. Le nombre de points attribués est dégressif en fonction de la place obtenue, de 10 en 10 pour les 5 premiers et premières, puis de 1 en 1 pour les suivants et suivantes. Le classement général du Challenge
            sera actualisé après chacune des 16 épreuves le composant, par addition des points obtenus dans chacune des courses disputées par les concurrents. Les classements par catégories d'âge seront établis à partir de ce même classement général,
            une fois les 16 épreuves terminées. En cas d'égalité entre deux coureurs, le classement par catégorie de chaque épreuve sera pris en compte pour départager les coureurs.<br />
            Un second classement, ne permettant pas de prétendre aux podiums officiels, sera réalisé pour classer les concurrents et concurrentes ayant réalisé 10 courses ou plus. Ils deviendront alors « super finisher » du Challenge.
          </p>

          <h4>Classement des clubs</h4>
          <p>
            Un classement par club est également réalisé, prenant en compte le nombre de finishers de chaque club et le nombre de points obtenus par ces mêmes finishers. Le total des points obtenus par les finishers d'un même club sera multiplié par
            le nombre de finishers du même club pour établir le classement général du club.<br />
            Un second classement par club, intitulé « performance clubs », ne permettant pas de prétendre au podium officiel, prendra quant à lui uniquement en compte les résultats des 5 meilleurs coureurs de chaque club.
          </p>
          <h4>Classement des entreprises</h4>
          <p>
            Un classement est enfin ouvert aux entreprises, prenant en compte le nombre de finishers de chaque entreprise et le nombre de points obtenus par ces mêmes finishers. Le total des points obtenus par les finishers d'une même entreprise sera
            multiplié par le nombre de finishers de la même entreprise pour établir le classement général de l'entreprise.<br />
            Un second classement par entreprise, intitulé « performance entreprises », ne permettant pas de prétendre au podium officiel, prendra quant à lui uniquement en compte les résultats des 3 meilleurs coureurs de chaque entreprise.
          </p>
          <h3>Article 5 : RÉCOMPENSES</h3>
          <p>Les lots seront attribués par catégorie (homme et femme distingués, non cumulables), selon le ou les :</p>
          <ul>
            <li>3 premiers et premiers Scratch</li>
            <li>1er Sénior</li>
            <li>1er Master 0</li>
            <li>1er Master 1</li>
            <li>1er Master 2</li>
            <li>1er Master 3</li>
            <li>1er Master 4</li>
            <li>1er Master 5</li>
            <li>1er Master 6</li>
            <li>1er Master 7</li>
            <li>1er Master 8</li>
            <li>1er Master 9</li>
            <li>1er Master 10</li>
            <li>1er Espoir</li>
            <li>1er Junior</li>
            <li>1er Cadet</li>
          </ul>
          <p>
            Les catégories d’âge affectées aux coureurs sont attribuées sur toute la durée du Challenge 2023, sur la base des règles d’affectation existant au 1er janvier 2023.<br />
            Un lot « Finisher » à l’effigie du Challenge Maritima récompensera les concurrents ayant terminé au moins huit épreuves sur les seize inscrites en 2023, toutes catégories confondues. Un lot spécial et/ou supplémentaire, récompensera les
            concurrents ayant terminé dix épreuves ou plus.<br />
            Des coupes et trophées récompenseront les clubs et entreprises s'illustrant dans leurs classements respectifs.<br />
            La date et le lieu de la remise des récompenses seront communiqués sur le site internet
            <a href="http://www.challenge-maritima.info" target="_blank">http://www.challenge-maritima.info</a>, une fois le classement général final établi.
          </p>
          <h3>Article 6 : DIFFUSION DES RÉSULTATS</h3>
          <p>
            Les classements complets, le règlement du Challenge, ainsi que l'ensemble des informations relatives au Challenge et à son actualité, seront disponibles sur le site internet
            <a href="http://www.challenge-maritima.info" target="_blank">http://www.challenge-maritima.info</a>.
          </p>
          <h3>Article 7 : RESPONSABILITÉS DES ORGANISATEURS</h3>
          <p>
            Les organisateurs déclinent toute responsabilité quant aux vols et accidents éventuels. Ils se réservent le droit de repenser les lots. Les contestations relatives au classement du Challenge devront être faites par mail à l'organisation
            du challenge à l'adresse challenge- maritima@maritima.info dans les 3 jours suivants la diffusion du classement général final. Tous les litiges seront exclusivement réglés par le responsable du Challenge Maritima.
          </p>
          <h3>Article 8 : DROIT À L'IMAGE</h3>
          <p>
            Le concurrent autorise les organisateurs ainsi que les ayants droits tels que partenaires et médias à utiliser les images fixes ou audiovisuelles sur lesquelles il peut apparaître, prises à l'occasion de leur participation à une des
            courses du "Challenge Maritima", sur tous supports, y compris les documents promotionnels et/ou publicitaires, dans le monde entier et pour la durée la plus longue prévue par la loi, les règlements, et les traités en vigueur.
          </p>
        </b-col>
      </b-row>
    </b-container>
    <p style="font-size: 12px; padding-bottom: 10px; text-align: center">
      <b>Généré par </b>
      <a href="https://sportips.fr" target="_blank"><img src="https://sportips.fr/ressources/logo_menu.png" style="display: inline; width: 80px" /></a>
    </p>
  </b-container>
</template>

<script>
import Navbar from "../components/Navbar.vue";
export default {
  components: {
    Navbar,
  },
  data() {
    return {
      fields: [
        { key: "num", label: "N°" },
        { key: "date", label: "Date" },
        { key: "name", label: "Nom" },
        { key: "distance", label: "Distance" },
      ],
      repartition_points: [
        { "Classement de la course": 1, "Points obtenus": 2000 },
        { "Classement de la course": 2, "Points obtenus": 1990 },
        { "Classement de la course": 3, "Points obtenus": 1980 },
        { "Classement de la course": 4, "Points obtenus": 1970 },
        { "Classement de la course": 5, "Points obtenus": 1960 },
        { "Classement de la course": 6, "Points obtenus": 1959 },
        { "Classement de la course": 7, "Points obtenus": 1958 },
        { "Classement de la course": 8, "Points obtenus": 1957 },
        { "Classement de la course": 9, "Points obtenus": 1956 },
        { "Classement de la course": "...", "Points obtenus": "..." },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
